<template>
    <div>
        <table class="table table-bordered responsive-table" id="recent_calls">
            <thead>
            <tr>
                <th>User</th>
                <th>Login time</th>
                <th>Device</th>
                <th>Browser</th>
                <th>Browser version</th>
                <th>Platform</th>
                <th>IP Address</th>
            </tr>
            </thead>
            <tbody id="recentCalls">
            <tr v-for="item in items">
                <td><a :href="item.user_profile_url">{{ item.username }}</a></td>
                <td> {{ item.login_time }}</td>
                <td> {{ item.user_device_type }}</td>
                <td> {{ item.browser }} <i class="fa fa-exclamation-circle" :title="item.http_user_agent"
                                           data-toggle="tooltip" data-placement="top" aria-hidden="true"></i></td>
                <td> {{ item.browserVersion }}</td>
                <td> {{ item.platform }}</td>
                <td><a :href="'https://tools.keycdn.com/geo?host='+item.user_device_ip"
                       target="_blank">{{ item.user_device_ip }}</a></td>
            </tr>
            </tbody>
        </table>
        <transition name="fade">
            <div class="loading" v-show="loading">
                <span class="fa fa-spinner fa-spin"></span> Loading
            </div>
        </transition>
        <nav>
            <ul class="pagination">
                <li v-if="currentPage > 1">
                    <a @click="viewPage(1,total_records)" href="javascript:void(0);">First</a>
                </li>
                <li v-if="currentPage > 1">
                    <a @click="viewPage(currentPage - 1,total_records)" href="javascript:void(0);"> << </a>
                </li>
                <li v-for="page in pages" v-if="(page - currentPage < 3 || page < 6 ) && (currentPage - page < 3 || page < pages.length-6)"
                    :class="{'active':currentPage === page}">
                    <a @click="viewPage(page,total_records)" href="javascript:void(0);">{{ page }}</a>
                </li>
                <li v-if="currentPage < pages">
                    <a @click="viewPage(currentPage +1,total_records)" href="javascript:void(0);"> >> </a>
                </li>
                <li v-if="currentPage < pages">
                    <a @click="viewPage(pages,total_records)" href="javascript:void(0);">Last</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import {getRecentLogins} from "@/modules/Reports/api/recentlogin";
import axios from "axios";
export default {
    name: "RecentLogin",
    data() {
        return {
            loading: false,
            items: [],
            pages: null,
            message: '',
            currentPage: 1,
            total_records:false,
        }
    },
    mounted() {
        // Detect when scrolled to bottom.
        this.viewPage(this.currentPage)
    },
    methods: {
        viewPage(page,total_records) {
            this.currentPage = page;
            axios.get("/dashboard/getRecentLogins?page=" + page+"&total_records="+total_records).then(response => {
                this.items = response.data.items;
                this.pages = response.data.pages;
                this.total_records = response.data.total_records;
            });
        },
        isScrolledIntoView(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }
    }
}
</script>

<style scoped>
.ibox-content {
    background-color: #d9dee1 !important
}
</style>